export class TaskFile {
  fileName: string;
  taskId: number;
  externalId: string;
  uploadDate: string;
  createdBy: string;
}
